import { render, staticRenderFns } from "./SidebarLayout2.vue?vue&type=template&id=2dfb54f0&scoped=true&"
import script from "./SidebarLayout2.vue?vue&type=script&lang=js&"
export * from "./SidebarLayout2.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLayout2.vue?vue&type=style&index=0&id=2dfb54f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb54f0",
  null
  
)

export default component.exports